var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('component-page', {
    attrs: {
      "title": "Radio",
      "enlarged-example-gap": ""
    },
    scopedSlots: _vm._u([{
      key: "basicUsage",
      fn: function fn() {
        return [_c('a-radio', {
          attrs: {
            "value": "first",
            "name": "basic-usage",
            "label": "First"
          },
          model: {
            value: _vm.basicUsageChecked,
            callback: function callback($$v) {
              _vm.basicUsageChecked = $$v;
            },
            expression: "basicUsageChecked"
          }
        }), _c('a-radio', {
          attrs: {
            "value": "second",
            "name": "basic-usage",
            "label": "Second"
          },
          model: {
            value: _vm.basicUsageChecked,
            callback: function callback($$v) {
              _vm.basicUsageChecked = $$v;
            },
            expression: "basicUsageChecked"
          }
        }), _c('a-radio', {
          attrs: {
            "value": "third",
            "name": "basic-usage",
            "label": "Third"
          },
          model: {
            value: _vm.basicUsageChecked,
            callback: function callback($$v) {
              _vm.basicUsageChecked = $$v;
            },
            expression: "basicUsageChecked"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('component-usage-example', {
    attrs: {
      "caption": "Label slot"
    }
  }, [_c('a-radio', {
    attrs: {
      "value": "left",
      "name": "label-slot"
    },
    model: {
      value: _vm.labelSlotChecked,
      callback: function callback($$v) {
        _vm.labelSlotChecked = $$v;
      },
      expression: "labelSlotChecked"
    }
  }, [_c('span', {
    staticClass: "label-slot-highlighter"
  }, [_vm._v("Le")]), _vm._v("ft ")]), _c('a-radio', {
    attrs: {
      "value": "right",
      "name": "label-slot"
    },
    model: {
      value: _vm.labelSlotChecked,
      callback: function callback($$v) {
        _vm.labelSlotChecked = $$v;
      },
      expression: "labelSlotChecked"
    }
  }, [_c('span', {
    staticClass: "label-slot-highlighter"
  }, [_vm._v("Ri")]), _vm._v("ght ")])], 1), _c('component-usage-example', {
    attrs: {
      "caption": "Disabled option"
    }
  }, [_c('a-radio', {
    attrs: {
      "label": "Checked",
      "disabled": ""
    }
  }), _c('a-radio', {
    attrs: {
      "value": "unchecked",
      "label": "Unchecked",
      "disabled": ""
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }